/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';

import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router';
import {
    object,
    shape,
    string,
    func,
} from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getProfileInfo } from '../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { trackEvent as track } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import brandtheme from '../../../../components/AppShell/brandtheme';
import { getCurrentBrandId } from '../../state/ducks/Common/Common-Selectors';
import { getPassportPageUrl } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import listItem from './LeftMenuListItem';

const styles = ({ palette }) => ({
    leftMenus: {
        textDecoration: 'none',
        listStyle: 'none',
        lineHeight: 1.5,
        minWidth: 160,
        borderRight: `1px solid ${palette.grey7}`,
        boxShadow: '2px -3px 4px rgb(47 47 47 / 15%)',
        '& > div': {
            height: '62px',
        },
    },
    listItem: {
        paddingLeft: '12px',
        width: '109px',
        fontSize: '16px !important',
        fontWeight: 400,
    },
    trackOrder: {
        marginTop: 'inherit',
    },
    selectedUrl: {
        backgroundColor: palette.bgContrastPrimaryColor || '#EBEBEB',
    },
    listWrapper: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '20px',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: palette.bgContrastPrimaryColor || '#EBEBEB',
        },
        '@media only screen and (max-width: 1366px) and (min-width: 1024px)': {
            paddingLeft: '2px',
        },
    },
    accountHolderName: {
        textAlign: 'center',
        fontSize: '20px !important',
        paddingTop: '30px',
        height: '80px !important',
        textTransform: 'capitalize',
    },
});

class AccountLeftMenu extends Component {
    handleListItemClicked = (url, currentUrl, regEx, userRole) => {
        const {
            history: { push }, trackPassportEvent, userProfile, passportUrl,
        } = this.props;
        if (url.includes('/account/passport')) {
            trackPassportEvent({
                eventCategory: 'Account Navigation',
                eventAction: 'Click',
                eventLabel: 'passport',
            });
        }
        if ((currentUrl !== url) && !(regEx?.test(currentUrl))) {
            if (userRole && (!userProfile?.passportStartDate || !userProfile?.passportEndDate || !userProfile?.passportFlag)) {
                return push(passportUrl);
            }
            push(url);
        }
        return null;
    };

    render() {
        const {
            classes, featureFlags, customClass, userProfile, brandId,
        } = this.props;
        const currentUrl = typeof window !== 'undefined' ? window.location.pathname : '/';
        const brandIconColor = brandtheme[brandId]?.palette?.colorPrimary;
        const listItemData = listItem(brandIconColor, true);
        return (
            <>
                <Grid className={`${classes.leftMenus} ${classes[customClass]} padding-left`} item xs={2}>
                    <>
                        <div className={classes.accountHolderName}>{userProfile.firstName}&apos;s Account</div>
                        {listItemData.map((list) => {
                            if ((list.flag
                                    && featureFlags[list.flag]
                                    && featureFlags[list.flag] === 'N')
                            ) {
                                return '';
                            }
                            return (
                                <div
                                    role="presentation"
                                    key={list.label}
                                    className={(currentUrl === list.url) || (list.regEx?.test(currentUrl))
                                        ? `${classes.listWrapper} ${classes.selectedUrl} border-bottom`
                                        : `${classes.listWrapper} border-bottom`}
                                    onClick={() => this.handleListItemClicked(list.url, currentUrl, list.regEx, list.userRole)}
                                >
                                    <span>{list.icon}</span>
                                    <span
                                        key={list.id}
                                        className={classes.listItem}
                                    > {list.label}
                                    </span>
                                </div>
                            );
                        })}
                    </>
                </Grid>
            </>
        );
    }
}

AccountLeftMenu.defaultProps = {
    history: {},
    customClass: '',
    userProfile: {},
    brandId: '',
    passportUrl: '',
};

AccountLeftMenu.propTypes = {
    classes: object.isRequired,
    userProfile: shape({
        passportStartDate: string,
        passportEndDate: string,
        passportFlag: string,
    }),
    history: object,
    customClass: string,
    featureFlags: object.isRequired,
    trackPassportEvent: func.isRequired,
    brandId: string,
    passportUrl: string,
};

const mapDispatchToProps = (dispatch) => ({
    trackPassportEvent: bindActionCreators(track, dispatch),
});

const mapStateToProps = (state) => ({
    userProfile: getProfileInfo(state),
    brandId: getCurrentBrandId(state),
    passportUrl: getPassportPageUrl(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withStyles(styles)(AccountLeftMenu)));
